export const TaskListStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
};
